
import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WorkShowcase from './components/WorkShowcase';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';

const App: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen selection:bg-blue-500/10 selection:text-blue-600">
      {/* Dynamic Background Elements */}
      <div className="fixed inset-0 -z-20 bg-slate-50"></div>
      <div className="fixed inset-0 -z-10 bg-grid pointer-events-none opacity-50"></div>
      
      {/* Animated Blobs */}
      <div className="fixed top-[-10%] left-[-5%] w-[500px] h-[500px] bg-blue-400/10 rounded-full blur-[100px] pointer-events-none animate-blob"></div>
      <div className="fixed top-[20%] right-[-10%] w-[600px] h-[600px] bg-purple-400/10 rounded-full blur-[120px] pointer-events-none animate-blob animation-delay-2000"></div>
      <div className="fixed bottom-[10%] left-[10%] w-[550px] h-[550px] bg-emerald-400/5 rounded-full blur-[100px] pointer-events-none animate-blob animation-delay-4000"></div>

      <Header isScrolled={isScrolled} />
      
      <main className="relative">
        <Hero />
        <Services />
        <WorkShowcase />
        <Pricing />
        <Contact />
      </main>

      <Footer />
    </div>
  );
};

export default App;
